<template>
  <a-modal :width="750" :open="open" :style="isMobile ? modalMobileStyleObject : ''" @cancel="closeForm" :footer="null">
    <h2>Изменение роли</h2>

    <a-divider style="margin: 16px 0"/>

    <a-radio-group v-model:value="roleForm.role" class="role-group">
      <a-card v-if="getRight('superadmin')" class="role-card">
        <a-radio value="superadmin" class="radio-title">Суперадмин</a-radio>
        <div class="grey-text">
          Суперадмин
        </div>
      </a-card>

      <a-card class="role-card">
        <a-radio value="admin" class="radio-title">HR Администратор</a-radio>
        <div class="grey-text">
          Главный администратор с полным доступом к системе
        </div>
      </a-card>

      <a-card class="role-card">
        <a-radio value="hr_department" class="radio-title">HR Подразделения</a-radio>
        <div class="grey-text">
          Управляет выбранными группами и продуктами в пределах лимитов
        </div>


        <div v-if="roleForm.role === 'hr_department'">
          <div class="admin-group-select">
            <div class="additional-label">Управление группами</div>
            <a-select
                v-model:value="roleForm.groups"
                mode="multiple"
                :placeholder="'Не выбрано'"
                :not-found-content="'Нет данных'"
                :label="'H'"
                class="admin-group"
            >
              <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
                {{ e.name }}
              </a-select-option>
            </a-select>
          </div>

          <div class="additional-label">
              Продукты и лимиты
          </div>
          <div v-if="quotasLoaded" class="order-list">
            <a-table
                :columns="getExtendedColumns('tests', 'Оценка')"
                rowKey="id"
                :data-source="tableData.tests"
                :table-layout="'fixed'"
                :scroll="{ x: '100%' }"
                :pagination="false"
                :locale="{ emptyText: emptySlot()}"
            >
              <template #bodyCell="{ column, text, record }">

                <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
                </template>

                <template v-if="column.dataIndex === 'quota'">
                  <a-input-number id="inputNumber" v-model:value="record.limit" :min="0" :max="100" :placeholder="'10'" />
                </template>

                <template v-if="column.dataIndex === 'has_access'">
                  <a-checkbox v-model:checked="record.access" :disabled="!record.limit"/>
                </template>
              </template>
            </a-table>

            <a-table
                :columns="getExtendedColumns('courses', 'Развитие (курсы, практикумы, тренажеры)')"
                rowKey="id"
                :data-source="tableData.courses"
                :scroll="{ x: '100%' }"
                :pagination="false"
                :locale="{ emptyText: emptySlot()}"
                :table-layout="'fixed'"
            >
              <template #bodyCell="{ column, text, record }">

                <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
                </template>

                <template v-if="column.dataIndex === 'quota'">
                  <a-input-number class="input-number" id="inputNumber" v-model:value="record.limit" :min="0" :max="100" :placeholder="'10'" />
                </template>
                <template v-if="column.dataIndex === 'has_access'">
                  <a-checkbox v-model:checked="record.access" :disabled="!record.limit" />
                </template>
              </template>
            </a-table>

            <a-table
                :columns="getShortListColumns('analytics', 'Просмотр аналитических отчетов')"
                rowKey="id"
                :data-source="tableData.analytics"
                :scroll="{ x: '100%' }"
                :pagination="false"
                :locale="{ emptyText: emptySlot()}"
                :table-layout="'fixed'"
            >
              <template #bodyCell="{ column, text, record }">

                <template v-if="column.dataIndex === 'free'">
                <span class="free-quotas">
                  {{ text }}
                </span>
                </template>

                <template v-if="column.dataIndex === 'has_access'">
                  <a-checkbox v-model:checked="record.access" />
                </template>
              </template>
            </a-table>
          </div>

          <div class="loading-block" v-else>
            <a-spin />
          </div>
        </div>

      </a-card>

      <a-card class="role-card">
        <a-radio value="staff" class="radio-title">Сотрудник</a-radio>
        <div class="grey-text">
          Видит свои результаты, проходит назначенные курсы
        </div>
      </a-card>
    </a-radio-group>

    <a-divider style="margin: 16px 0"/>

    <div class="button-row-full">
      <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
      <a-button :loading="isProcessing" class="primary-button" @click="handleRoleChange">Применить</a-button>
    </div>
  </a-modal>
</template>

<script>
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import {InfoCircleFilled, PlusOutlined, ExclamationCircleOutlined, MinusOutlined} from "@ant-design/icons-vue";
import {h, onMounted} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {getWordFormBasedOnTheCount} from "@/views/Report/utils";
import getReportName from "@/mixins/getReportName";
import { message } from 'ant-design-vue';
import tools from "@/mixins/dictionaries/toolsTranslate";
import {Divider} from "ant-design-vue";
import useCheckRights from "../../mixins/useCheckRights";

export default {
  methods: {getWordFormBasedOnTheCount},
  components: {
    InfoCircleFilled,
    ExclamationCircleOutlined,
    PlusOutlined
  },
  emits: ['close'],
  props: {
    role: String,
    open: Boolean,
    userId: [Number, String],
  },
  setup(props, context) {

    const store = useStore();
    const { getRight } = useCheckRights();
    const roleForm = reactive({
      role: props.role,
      groups: [],
    });
    const isProcessing = ref(false);
    const allGroups = computed(() => store.state.group.groups);
    const groups = ref([]);

    const handleRoleChange = () => {

      if (roleForm.role === 'hr_department' && !roleForm.groups.length) {
          message.info('Необходимо выбрать управляемые группы');
          return;
      }

      isProcessing.value = true;

      const tests = (tableData.tests || []).map((item) => ({
        type: item.product_id,
        title: item.product,
        limit:item.limit ?? 0,
        access: item.access ?? false,
      }));

      const courses = (tableData.courses || []).map((item) => ({
        course_id: item.product_id,
        title: item.product,
        limit: item.limit ?? 0,
        access: item.access ?? false,
      }));

      const analytical_reports = (tableData.analytics || []).map((item) => ({
        type: item.product,
        access: item.access ?? false,
      }));

      const updateObject = {
        user_id: props.userId,
        role: roleForm.role,
        groups: roleForm.groups ?? [],
        tests,
        courses,
        analytical_reports,
      };

      store.dispatch('users/updateRole', updateObject)
          .then(() => {
            message.success('Роль обновлена');
            context.emit('submitted');
          })
          .catch(() => {
            message.error('Произошла ошибка');
          })
          .finally(() => {
            isProcessing.value = false;
          });
    };

    const closeForm = () => {
      store.dispatch('relations/clearInsufficientProducts');
      context.emit('close');
    }

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 180,
          align: 'left',
        },
        {
          title: 'Доступно',
          dataIndex: 'free',
          key: 'free',
          width: 60,
          align: 'right',
        },
        {
          title: 'Доступ',
          dataIndex: 'quota',
          key: 'quota',
          width: 60,
          align: 'right',
        },
        {
          title: 'Доступ',
          dataIndex: 'has_access',
          key: 'has_access',
          width: 80,
          align: 'right',
        },
      ];
    }

    const getShortListColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 240,
          align: 'left',
        },
        {
          title: 'Доступ',
          dataIndex: 'has_access',
          key: 'has_access',
          width: 80,
          align: 'right',
        },
      ];
    }

    const emptySlot = () =>
        h('div', {class: 'no-data-wrapper'}, [
          h('img', {src: NotFoundIcon, class: 'no-data-image'}),
          h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
        ]);

    const tableData = reactive({
      tests: [],
      courses: [],
      analytics: [],
    });

    const companyQuotas = computed(() => store.state.company.userQuotas);
    const totalProductsToOrder = ref(0);

    const quotasLoaded = ref(true);

    onBeforeMount(() => {
      quotasLoaded.value = false;

      store.dispatch('company/getUserQuotas').then(() => {
        prepareData();
        quotasLoaded.value = true;
      });

      store.dispatch("group/getGroups").then(() => {
        groups.value = allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        });
      });
    });

    const prepareData = () => {
      tableData.tests = Object.entries(companyQuotas.value.test_passings)
          .filter(([key]) => key !== 'empty')
          .map(([key, value]) => {
            return {
              product: getReportName(key),
              product_id: key,
              free: value.free,
              sub_type: 'tests',
            }
          });

      tableData.courses = Object.entries(companyQuotas.value.course_passings.total).map(([key, value]) => {
        let freePassings = companyQuotas.value.course_passings.free.find((course) => course.course_id === value.course_id);

        return {
          product: value.name,
          product_id: value.course_id,
          free: freePassings?.count ?? 0,
          sub_type: 'courses',
        }
      });

      tableData.analytics = [
        {
          product: 'Эталонный профиль',
          product_id: 'reference_profile',
          has_access: !!companyQuotas.value?.reference_profiles?.free_count ?? 0,
          validUntil: '',
          timeRemaining: null,
          sub_type: 'analytics',
        },
      ];
    }

    const isMobile = ref(window.innerWidth <= 768)

    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    return {
      getRight,
      roleForm,
      getExtendedColumns,
      getShortListColumns,
      emptySlot,
      closeForm,
      tableData,
      quotasLoaded,
      totalProductsToOrder,
      isMobile,
      handleRoleChange,
      isProcessing,
      groups,
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
}

.form-group-row {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  row-gap: 10px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    row-gap: 0;
  }
}

.input-form-item {
  min-width: 49%;
}

.password-radio-group,
.checkbox-group {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.password-field {
  margin: 10px;
}

:deep(.ant-input-focused) {
  border-color: var(--main-green);
}

.ant-input:hover,
.ant-input:focus {
  border-color: var(--main-green);;
}

.ant-input:focus,
.ant-select-focused .ant-select-selector {
  box-shadow: 0 0 0 2px var(--polar-green);
}

.ant-input-affix-wrapper:hover,
.ant-input-affix-wrapper-focused {
  border-color: var(--main-green);
}

.ant-input-affix-wrapper-focused {
  box-shadow: 0 0 0 2px var(--polar-green);
}

:deep(.ant-form-item-label) {
  padding: 0;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}

.button-row {
  display: flex;
  column-gap: 10px;
  row-gap: 15px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.successful-text {
  margin: 16px 0 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

.successful-text p {
  margin-bottom: 0;
}

.successful-text span {
  font-size: 14px;
  color: var(--grey-text)
}

.successful-text .happy-smile,
.successful-text .frown-smile {
  font-size: 65px;
}

.successful-text .happy-smile {
  color: var(--main-green);
}

@media (max-width: $mobile-breakpoint) {
  .secondary-button {
    width: 100%;
  }
}

.free-quotas {
  color: var(--grey-text)
}

:deep(th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-row td) {
  padding: 10px !important;
}

.order-list {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

:deep(.ant-input-number-input),
:deep(.ant-input-number-input::placeholder) {
  text-align: right;
}

:deep(.ant-input-number-handler-wrap) {
  display: none;
}

@media (max-width: $mobile-breakpoint) {
  :deep(.ant-input-number) {
    width: 50px !important;
  }
}

:deep(.group-select) {
  margin: 15px 0;
}

.role-group {
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  .grey-text {
    font-size: 14px;
    padding-left: 25px;
  }

  .admin-group-select {
    margin: 16px 0;
    width: 100%;
  }
}

.button-row-full {
  margin-left: auto;
  display: flex;
  column-gap: 8px;
  row-gap: 10px;
  justify-content: flex-end;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;

    btn {
      width: 100%;
    }
  }
}

.additional-label {
  color: var(--grey-text);
  font-size: 14px;
  margin-bottom: 4px;
}

.admin-group {
  width: 100%;
}
</style>